import React, {useState, useRef, useEffect} from "react";
import {Button, Col, Row} from "react-bootstrap";
import BootstrapTable from "react-bootstrap/Table";
import Pagination from "../../components/common/Pagination";
import TableTopBar from "../../components/tables/top/TableTopBar";
import PopUp from "../../components/popUp/PopUp";
import {delAllSysFcltyDeptDetail, getSysFcltyDeptListAll} from "../../api/apiClient";
import Swal from "sweetalert2";
import '@sweetalert2/theme-dark/dark.scss';
import RegFcltyDept from "../../pages/subPages/RegFcltyDept";
import {exportExcel} from "../../common/exportExcel";
import {exportPdf} from "../../common/exportPdf";
import useAuth from "../../hook/useAuth";
import usePdf from "../../hook/usePdf";

const TableFcltyDept = ({
                          currentPage,
                          setCurrentPage,
                          listPageSize,
                          setListPageSize,
                          total,
                          tableList,
                          updateList,
                          setIsSearch,
                          setTableList,
                          setTotal,
                          searchParam
                        }) => {

  /*const [auth, setAuth] = useState("0");

  useEffect(() => {
    setAuth(sessionStorage.getItem("CURRENT_AUTH"));
  }, []);*/

  const auth = useAuth();

  // select ////////////////////////////////////
  const updatePageSize = (aSize) => {
    setIsSearch(true);
    setCurrentPage(1);
    setListPageSize(parseInt(aSize));
  };

  const tableRef = useRef(null);
  const [isExport, setIsExport] = useState(false);

  const onDownload = () => {
    exportExcel(tableRef, "화재안전관리자_.xls")
  }

  const getAllList = () => {
    setIsExport(true);

    getSysFcltyDeptListAll(
        currentPage, listPageSize,
        searchParam.searchFcltyNo)
        .then((res) => {
              // console.log(res);
              if (res.data.data !== undefined) {
                setTableList(res.data.data.list);
                setTotal(res.data.data.total);
              }
            }
        );
  };

  const downloadExcelToTable = () => {
    getAllList();

    Swal.fire({
      title: `EXCEL 다운로드 하시겠습니까?`,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: `확인`,
      cancelButtonText: '취소'
    }).then((result) => {
      if (result.isConfirmed) {
        onDownload();
      }
      setIsExport(false);

      updateList();
    })
  };

  const exportReport = () => {
    getAllList();

    Swal.fire({
      title: `PDF 다운로드 하시겠습니까?`,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: `확인`,
      cancelButtonText: '취소'
    }).then((result) => {
      if (result.isConfirmed) {
        exportPdf(tableRef, '화재안전관리자.pdf');
      }
      setIsExport(false);

      updateList();
    });
  };

  // 체크박스
  // 체크된 아이템을 담을 배열
  const [checkItems, setCheckItems] = useState([]);

  // 체크박스 단일 선택
  const handleSingleCheck = (checked, id) => {
    if (checked) {
      // 단일 선택 시 체크된 아이템을 배열에 추가
      setCheckItems(prev => [...prev, id]);
    } else {
      // 단일 선택 해제 시 체크된 아이템을 제외한 배열 (필터)
      setCheckItems(checkItems.filter((el) => el !== id));
    }
  };

  // 체크박스 전체 선택
  const handleAllCheck = (checked) => {
    if (checked) {
      // 전체 선택 클릭 시 데이터의 모든 아이템(id)를 담은 배열로 checkItems 상태 업데이트
      const idArray = [];
      tableList.forEach((el) => idArray.push(el.pic_no));
      setCheckItems(idArray);
    } else {
      // 전체 선택 해제 시 checkItems 를 빈 배열로 상태 업데이트
      setCheckItems([]);
    }
  };

  // delete ////////////////////////////////////
//  const delItem = () => {
//    Swal.fire({
//      title: `삭제하시겠습니까?`,
//      text: `선택한 id(${checkItem.pic_no}) 항목을 삭제합니다.`,
//      icon: 'warning',
//      showCancelButton: true,
//      // confirmButtonColor: '#3085d6',
//      // cancelButtonColor: '#d33',
//      confirmButtonText: '확인',
//      cancelButtonText: '취소'
//    }).then((result) => {
//      if (result.isConfirmed) {
//        delSysFcltyDeptDetail(checkItem.pic_no).then(r => {
//            updateList();
//            Swal.fire(
//                '삭제되었습니다!',
//                'Your file has been deleted.',
//                'success'
//            )
//        });

//      }
//    })
//  }

  // 일괄 삭제
  const delItem = (e) => {
    /*if (checkItems.length < 1) {
      Swal.fire("항목을 선택하세요.");
      return;
    }*/
    const deleteId = e.target.dataset.id;

    Swal.fire({
      title: `삭제하시겠습니까?`,
      text: `선택한 id(${deleteId}) 항목을 삭제합니다.`,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: '확인',
      cancelButtonText: '취소'
    }).then((result) => {
      if (result.isConfirmed) {
        delAllSysFcltyDeptDetail(deleteId)
            .then(res => {
              if (res.data.status === 200) {
                Swal.fire(
                    '삭제되었습니다!',
                    '',
                    'success'
                );
                // setCheckItems([]);
                setIsSearch(true);
                updateList();
              }
            })
            .catch(err => {
              Swal.fire(
                  err.response.data.message,
                  '',
                  'error'
              );
            });
      }
    })
  };

  // Reg ///////////////////////////////////////
  const regItem = (e = null) => {
    const auth = sessionStorage.getItem('CURRENT_AUTH');
    if (auth != 2) {
      Swal.fire('권한이 없습니다.');
    } else {
      setPopup({
        isVisible: true,
        pic_no: null,
      });
    }
  }

  /* 팝업을 위한 state */
  const [openPopup, setPopup] = useState({isVisible: false, pic_no: 0});

  const closePopup = () => {
    setPopup({isVisible: false, pic_no: 0});
    setIsSearch(true);
    updateList();
  }

  const handleOpenPopup = (e = null) => {
    // console.log("## popup :: ", e.target.dataset.id);
    setPopup({
      isVisible: true,
      pic_no: e.target.dataset.id,
    });
  };

  return (
      <>
        <PopUp
            propTitle={openPopup.pic_no ? '화재안전관리자 수정' : '화재안전관리자 등록'}
            propShow={openPopup.isVisible}
            propSize={'lg'}
            setShow={closePopup}
        >
          <RegFcltyDept
              propPicNo={openPopup.pic_no}
              hClose={closePopup}
          />
        </PopUp>
        <Row>
          <Col md={6} className={""}>
            <TableTopBar
                propSelectOption={{
                  isEnable: true,
                  selItems: [15, 30, 50], //미구현
                  setFunc: updatePageSize,
                }}
                propExcelExport={{
                  isEnable: true,
                  exportFilename: 'doc.xlsx',
                  getFunc: null,
                }}
                propExcelDownload={{
                  isEnable: true,
                  getFunc: downloadExcelToTable,
                }}
                /*propPdfExport={{
                  isEnable: true,
                  // exportFilename: 'doc.pdf',
                  getFunc: exportReport,
                }}*/
                propPdf={{
                  isEnable: true,
                  getFunc: usePdf({
                    tableRef: tableRef,
                    setIsExport: setIsExport,
                    getAllList: getAllList,
                    updateList: updateList,
                    filename: '화재안전관리자',
                  }),
                }}
                propDelete={{
                  isEnable: false,
                  delFunc: delItem,
                }}
                propReg={{
                  isEnable: auth === "2",
                  regFunc: regItem,
                }}
                // propControl = {{
                //     isEnable: true,
                //     ctlFunc: null,
                // }}
            />
          </Col>

          <Col md={12}>
            <div className={"table-responsive text-nowrap"}>
              <BootstrapTable hover className={"table text-center"} ref={tableRef}>
                <thead className={"table-head text-secondary"}>
                <tr className={"text-start"}>
                  {/*<th className={"table-checkbox"}>
                    <input
                        type="checkbox"
                        name='check-all'
                        className={"checkbox check-all"}
                        onChange={(e) => handleAllCheck(e.target.checked)}
                        checked={checkItems.length === tableList.length}
                    />
                  </th>*/}
                  <th className={"col"}>시설명</th>
                  <th className={"col"}>담당자명</th>
                  <th className={"col"}>담당업무</th>
                  <th className={"col"}>전화번호</th>
                  <th className={"col"}>등록일</th>
                  {!isExport && auth === "2" ? <th className={"col"}></th> : ''}
                </tr>
                </thead>
                <tbody className={`table-body text-start ${isExport ? "" : "text-white"} `}>
                {
                  Array.isArray(tableList) ?
                      (tableList.map((elem, idx) => {
                        return <tr key={idx}>
                          <td>{elem.fclty_nm}</td>
                          <td>{elem.pic_nm}</td>
                          <td>{elem.pic_job}</td>
                          <td>{elem.pic_telno}</td>
                          <td>{elem.crt_dt_str}</td>
                          {
                            !isExport && auth === "2" ?
                                (<td>
                                  <Button type={"button"} variant="primary"
                                          onClick={handleOpenPopup}
                                          data-id={elem.pic_no}
                                  >
                                    수정
                                  </Button>
                                  <span> </span>
                                  <Button type={"button"} variant="danger"
                                          data-id={elem.pic_no}
                                          onClick={delItem}
                                  >
                                    삭제
                                  </Button>
                                </td>) : ''
                          }
                        </tr>;
                      })) :
                      ('')
                }

                </tbody>
              </BootstrapTable>
            </div>
          </Col>
          <Col className={""}>
            <Pagination
                propCurPage={currentPage}
                propTotal={total}
                propPageSize={listPageSize}
                propSetNewPage={setCurrentPage}
            />
          </Col>
        </Row>
      </>
  );
};


export default TableFcltyDept;
